import React from 'react';
import {Route, Routes} from "react-router-dom";
import Opportunities from "../../../pages/dashboard/company/opportunities";
import Index from "../../../pages/dashboard/company";
import Profile from "../../../pages/dashboard/profile";
import Communication from "../../../pages/dashboard/communication";
import Languages from "../../../pages/dashboard/languages";

const CompanyRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="profile" element={<Profile/>} />
                <Route path="communication" element={<Communication/>} />
                <Route path="languages" element={<Languages/>} />
                <Route path="company" element={<Index />} />
            </Routes>
        </>
    );
};

export default CompanyRoutes;